import { render } from "./selectFoodList.vue?vue&type=template&id=5d9102f1"
import script from "./selectFoodList.vue?vue&type=script&lang=js"
export * from "./selectFoodList.vue?vue&type=script&lang=js"

import "./selectFoodList.vue?vue&type=style&index=0&id=5d9102f1&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__